import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import { Card, Form } from "react-bootstrap";
import { useState } from "react";
import { toast } from "react-toastify";
import { IconUserOff } from "@tabler/icons-react";

const DeactivateUserModal = ({ isOpen, onClose, fetchUsers }) => {
  const [reason, setReason] = useState("Other");
  // const { postData: deactivateUser } = usePostRequest(API_ENDPOINTS.GET_ROLES);
  const { postData: deactivateUserStatus } = usePostRequest(API_ENDPOINTS.DEACTIVATE_USER);


  const handleReasonChange = (event) => {
    setReason(event.target.value);
  };

  const onDeactivateUserSuccess = (response) => {
    toast.success(response.message);
    fetchUsers();
  };

  const onDeactivateUserError = (error) => {
    toast.success(error.message);
  };

  const handleDeactivateUser = (user) => {
    deactivateUserStatus(
      {
        status: !user?.is_active,
        username: user?.username,
        remark: reason,
      },
      onDeactivateUserSuccess,
      onDeactivateUserError
    );
    onClose()
  };

  return (
    <Modal centered show={isOpen?.show} onHide={onClose}>
      <Modal.Header className="gap-2" closeButton>
        <span className="avatar bg-pink-lt rounded-circle">
          <IconUserOff />
        </span>
        <div>
          <Modal.Title>Deactivate Account</Modal.Title>
          <Card.Subtitle>
            Please Select Reason for Deactivate Account{" "}
          </Card.Subtitle>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Form.Label>Select Reason</Form.Label>
        <Form.Select value={reason} onChange={handleReasonChange}>
          <option value="Employment Terminated">Employment Terminated</option>
          <option value="Employee Resigned">Employee Resigned</option>
          <option value="Inactive Account">Inactive Account</option>
          <option value="Other">Other</option>
        </Form.Select>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="btn-warning"
          onClick={() => handleDeactivateUser(isOpen?.user)}
        >
          Deactivate Account
        </Button>
        <Button variant="outline-danger" onClick={onClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeactivateUserModal;
